import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'sm-text-groups',
  standalone: true,
  imports: [InputTextModule, ButtonModule, CommonModule, FormsModule, TranslateModule],
  templateUrl: './text-groups.component.html',
  styleUrl: './text-groups.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextGroupsComponent implements OnInit {
  private _singular?: string;
  @Input()
  set singular(value: string | undefined | null) {
    this._singular = value ?? 'something-in-the-way';
  }
  get singular(): string {
    return this._singular!;
  }
  @Input() value: string[] = [];
  @Input() onChange?: (event: string[]) => void;
  @Input() disabled?: boolean;
  @Input() error: string[] = [];

  uid = new Date().getTime();

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method, @typescript-eslint/no-empty-function
  ngOnInit() {}

  add() {
    this.value.push('');
    this.onChange?.(this.value);
  }

  update(index: number, newValue: string) {
    const newArray = [...this.value];
    newArray[index] = newValue;
    this.value = newArray;
    this.onChange?.(newArray);
  }

  remove(index: number) {
    this.value.splice(index, 1);
    this.onChange?.(this.value);
  }

  clearAll() {
    this.value = [];
    this.onChange?.(this.value);
  }

  trackByFn(index: number) {
    return index;
  }

  repeatChar(i: number, repeatChar = 'OO') {
    return Array(i + 1).join(repeatChar);
  }
}
